module.exports = __webpack_public_path__ + "assets/images/casino.13c3be9a191bfe0cdd722f2b22477a97.svg";